import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import type {DayOfWeekLayoutVo} from '../../common/shared/api/karina/vo/dayOfWeek/DayOfWeekLayoutVo.interface';

/**
 * 요일연재 Layout 조회
 *
 * Origin: pageKarinaApi.getDayOfWeekLayout
 * API: GET /v1/tab/dayofweek
 */
export async function getTabDayOfWeek(
  dayUid?: number,
  options?: FetcherOptions
): Promise<ApiResultVo<DayOfWeekLayoutVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/view/v1/tab/dayofweek',
    {
      method: 'GET',
      params: {
        day_uid: dayUid,
      },
    },
    options
  );
  return response.data;
}
